import { TinymceOptions } from "../../options";

export const DetailsTinymceOptions = (options: any, plugins?: string) => {
    const config: any = {
        ...TinymceOptions.defaultAdmin,
        add_form_submit_trigger: true,
        entity_encoding: "raw",
        height: 250,
        plugins: [
            "autolink lists link charmap preview hr anchor",
            "searchreplace visualblocks visualchars code fullscreen",
            "insertdatetime media nonbreaking save table contextmenu directionality",
            "emoticons paste",
            (plugins || ""),
        ],
        statusbar: true,
        toolbar1: "copy paste | undo redo | bold italic | bullist numlist | subscript superscript | link unlink anchor | charmap",
        ...(options || []),
    };

    return config;
};



// WEBPACK FOOTER //
// ./src/models/abstract/AbstractTinymce.ts